
import Vue from "vue";
import { Component } from "vue-property-decorator";
import NotificationViewer from "./Notification.vue";
import { BreakdanceNotification } from "@/types/notifications";
import { uiStore } from "@/store/store";
import NotificationLogger from "@/lib/notifications/notifications";
import RegeneratingCacheProgress from "@/components/Notifications/RegeneratingCacheProgress.vue";

@Component({
  components: {
    RegeneratingCacheProgress,
    NotificationViewer
  }
})
export default class Notifications extends Vue {
  get notifications(): BreakdanceNotification[] {
    return uiStore.notifications;
  }

  dismissAll() {
    NotificationLogger.dismissAll();
  }

  dismissNotification(index: number) {
    NotificationLogger.dismiss(index);
  }
}
